"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _numberFormatter = require("../../helpers/numberFormatter");
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _PaginationContainer = _interopRequireDefault(require("../common/Pagination/PaginationContainer"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _OrderListMobileExpandedComponent = _interopRequireDefault(require("./OrderListMobileExpandedComponent"));
var _ActivityCellComponents = require("../RecentActivity/ActivityCellComponents");
require("./OrdersListComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('orders-list');
var flexTable = (0, _cssClassesHelper.getBEMClasses)('flex-table');
var OrdersListComponent = /*#__PURE__*/function (_React$Component) {
  function OrdersListComponent(props) {
    var _this;
    _classCallCheck(this, OrdersListComponent);
    _this = _callSuper(this, OrdersListComponent, [props]);
    _defineProperty(_this, "onOrderExpand", function (orderId, itemId) {
      var currentOrders = _this.state.expandedOrders;
      if (currentOrders.indexOf(itemId) !== -1) {
        var newexpandedOrders = currentOrders;
        newexpandedOrders.splice(newexpandedOrders.indexOf(itemId), 1);
        _this.setState({
          expandedOrders: newexpandedOrders
        });
      } else {
        currentOrders.push(itemId);
        _this.props.FetchAccountTradesForOrderId(orderId, 1);
        _this.setState({
          expandedOrders: currentOrders
        });
      }
    });
    _defineProperty(_this, "onOrderListExpand", function () {
      var orders = _this.props.orders;
      var currentOrders = orders.map(function (item) {
        return item.itemId;
      });
      if (_this.state.expandedOrders.length === 0) {
        _this.setState({
          expandedOrders: currentOrders
        });
      } else {
        _this.setState({
          expandedOrders: []
        });
      }
    });
    _defineProperty(_this, "renderExpandedItem", function (order) {
      var t = _this.props.t;
      var currentOrders = _this.state.expandedOrders;
      var _this$props = _this.props,
        decimalPlaces = _this$props.decimalPlaces,
        accountTrades = _this$props.accountTrades;
      var isMobile = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod/i);
      if (currentOrders.indexOf(order.itemId) !== -1 && !isMobile) {
        return _this.props.accountTrades.map(function (trade) {
          return trade.OrderId === order.orderId;
        }).indexOf(true) === -1 ? /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('no-data')
        }, t('No data is available')) : /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('items-container', 'expanded')
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('header')
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('column', 'header')
        }, '       '), /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('column', 'header')
        }, t('Side')), /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('column', 'header')
        }, t('Quantity')), /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('column', 'header')
        }, t('Price')), /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('column', 'header')
        }, t('Notional')), /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('column', 'header')
        }, t('Trade ID')), /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('column', 'header')
        }, '        ')), _this.props.accountTrades.map(function (trade, index) {
          return trade.OrderId === order.orderId && /*#__PURE__*/_react["default"].createElement("div", {
            key: "".concat(trade.TradId, " : ").concat(index.toString()),
            className: bemClasses('row', 'expanded')
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: bemClasses('column', 'expanded')
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: bemClasses('column', ['expanded', 'side'])
          }, trade.Side), /*#__PURE__*/_react["default"].createElement("div", {
            className: bemClasses('column', 'expanded')
          }, "".concat((0, _numberFormatter.formatNumberToLocale)(trade.Quantity, decimalPlaces[order.product1Symbol]), " ").concat(order.product1Symbol)), /*#__PURE__*/_react["default"].createElement("div", {
            className: bemClasses('column', 'expanded')
          }, order.product2Symbol === 'USD' ? "$ ".concat((0, _numberFormatter.formatNumberToLocale)(trade.Price, decimalPlaces[order.product2Symbol]), " ").concat(order.product2Symbol) : "".concat((0, _numberFormatter.formatNumberToLocale)(trade.Price, decimalPlaces[order.product2Symbol]), " ").concat(order.product2Symbol)), /*#__PURE__*/_react["default"].createElement("div", {
            className: bemClasses('column', 'expanded')
          }, order.product2Symbol === 'USD' ? "$ ".concat((0, _numberFormatter.formatNumberToLocale)(trade.Quantity * trade.Price, decimalPlaces[order.product2Symbol]), " ").concat(order.product2Symbol) : "".concat((0, _numberFormatter.formatNumberToLocale)(trade.Quantity * trade.Price, decimalPlaces[order.product2Symbol]), " ").concat(order.product2Symbol)), /*#__PURE__*/_react["default"].createElement("div", {
            className: bemClasses('column', ['expanded', 'id'])
          }, trade.TradeId), /*#__PURE__*/_react["default"].createElement("div", {
            className: bemClasses('column', 'expanded')
          }));
        }));
      } else if (currentOrders.indexOf(order.itemId) !== -1) {
        return /*#__PURE__*/_react["default"].createElement(_OrderListMobileExpandedComponent["default"], {
          decimalPlaces: decimalPlaces,
          order: order,
          trades: accountTrades.filter(function (item) {
            return item.OrderId === order.orderId;
          })
        });
      }
    });
    _defineProperty(_this, "renderIdStatusColumn", function (order) {
      var showOrderStatus = _this.props.showOrderStatus;
      if (showOrderStatus) {
        return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.Status, {
          value: {
            id: order.orderId,
            status: order.orderType
          },
          customClass: bemClasses('column')
        });
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('column', 'id')
        }, order.orderId);
      }
    });
    _defineProperty(_this, "renderItem", function (order, key) {
      var currentOrders = _this.state.expandedOrders;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: key
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('row-container')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        onClick: function onClick() {
          _this.onOrderExpand(order.orderId, order.itemId);
        },
        className: bemClasses('btn')
      }, currentOrders.indexOf(order.itemId) !== -1 ? '-' : '+'), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('row')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column')
      }, order.instrument), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column', 'side')
      }, order.side), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column')
      }, order.quantity), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column')
      }, order.product2Symbol === 'USD' ? "$".concat(order.avgPrice) : order.avgPrice), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column')
      }, order.product2Symbol === 'USD' ? "$".concat(order.notional) : order.notional), _this.renderIdStatusColumn(order), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column')
      }, order.dateTime))), _this.renderExpandedItem(order, key));
    });
    _defineProperty(_this, "renderEmptyRows", function (count) {
      var emptyRows = [];
      for (var i = 0; i < count; i++) {
        emptyRows.push(/*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('empty-row'),
          key: i
        }));
      }
      return emptyRows;
    });
    _defineProperty(_this, "renderOrders", function () {
      var _this$props2 = _this.props,
        usePagination = _this$props2.usePagination,
        orders = _this$props2.orders,
        pageSize = _this$props2.pageSize,
        showOnlyActivePage = _this$props2.showOnlyActivePage,
        minRow = _this$props2.minRow;
      if (usePagination) {
        var totalPages = Math.ceil(orders.length / pageSize || orders.length);
        return /*#__PURE__*/_react["default"].createElement(_PaginationContainer["default"], {
          totalPages: totalPages,
          content: function content(page) {
            var rows = orders.slice(pageSize * page, pageSize * (page + 1));
            var rowsContent = rows.map(function (row, index) {
              return _this.renderItem(row, index);
            });
            minRow && rowsContent.push(_this.renderEmptyRows(minRow - rows.length));
            return rowsContent;
          },
          componentName: "OrdersListComponent",
          showOnlyActivePage: showOnlyActivePage,
          customClass: bemClasses(),
          containerClassName: flexTable('pagination-container')
        });
      } else {
        return orders.map(function (order, index) {
          return _this.renderItem(order, index);
        });
      }
    });
    _this.state = {
      expandedOrders: []
    };
    return _this;
  }
  _inherits(OrdersListComponent, _React$Component);
  return _createClass(OrdersListComponent, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props3 = this.props,
        orders = _this$props3.orders,
        showOrderStatus = _this$props3.showOrderStatus,
        allowExpandedOrders = _this$props3.allowExpandedOrders;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('container')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('header')
      }, allowExpandedOrders && /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        onClick: this.onOrderListExpand,
        className: bemClasses('order-btn')
      }, this.state.expandedOrders.length === 0 ? '+' : '-'), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column', 'header')
      }, t('Instrument')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column', 'header')
      }, t('Side')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column', 'header')
      }, t('Quantity')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column', 'header')
      }, t('Average Price')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column', 'header')
      }, t('Notional')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column', 'header')
      }, showOrderStatus ? t('Order ID/Status') : t('Order ID')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('column', 'header')
      }, t('Date/Time'))), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('items-container')
      }, orders.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('no-data')
      }, t('No data is available')) : this.renderOrders())));
    }
  }]);
}(_react["default"].Component);
OrdersListComponent.defaultProps = {
  pageSize: 8,
  showOnlyActivePage: false,
  usePagination: false,
  showOrderStatus: false,
  allowExpandedOrders: true
};
OrdersListComponent.propTypes = {
  FetchAccountTradesForOrderId: _propTypes["default"].func.isRequired,
  orders: _propTypes["default"].array.isRequired,
  accountTrades: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('order')(OrdersListComponent);